/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
//  error msg dispatch function
export const dispatchErrorMsgCms = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CMS,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgCms([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgCms([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
export const dispatchFrom = (data) => ({
  type: actionTypes.GET_FROM,
  payload: data,
});

export const getQuarterData = () => (dispatch) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
  const currentYear = currentDate.getFullYear();
  const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter
  const formattedQuarter = `${currentQuarter}Q${currentYear.toString()}`;
  dispatch(dispatchFrom(formattedQuarter));
};

export const dispatchQuarterlyCms = (data) => ({
  type: actionTypes.GET_QUARTERLY_CMS,
  payload: data,
});
export const getQuarterlyCms = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTERLY_CMS, value)
    .then((response) => {
      if (response.data.quarterlyCmsUroaReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchQuarterlyCms(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchQuarterlyCms([]));
    });
};
// refresh data
export const refreshCMSUroa = () => ({
  type: actionTypes.SET_REFRESH_DATA_CMS,
  payload: {},
});
export const refreshCMSUroaDisplay = () => ({
  type: actionTypes.REFRESH_DATA_CMS_DISPLAY,
  payload: {},
});
